<mcg-window #formEdit style="overflow: hidden;" (actionButtonClicked)="actionButtonClicked($event)" [actions]="actions" [width]="950" [height]="490" [canResize]="false"
  [title]="translate('Edicion_subflotas')" (onClose)="onCloseEdit()" (windowClosed)="onCloseEdit()" (onOpen)="onOpenEditSubflota()">
  <div class="row">
    <div class="rowC" style="float: left; width: calc(20% - 10px);">
      <div style="margin-top: 5px">
        {{ translate('Nombre') }}
      </div>
      <jqxInput #ebNombre [(ngModel)]="subflotaEdit.Nombre" [width]="'100%'" [height]="25" [disabled]="!canEdit">
      </jqxInput>
    </div>

    <div class="rowC" style="float: left; width: calc(80% - 25px); margin-left: 25px;">
      <div style="margin-top: 5px">
        {{translate('Observaciones')}}
      </div>
      <jqxInput [(ngModel)]="subflotaEdit.Observaciones" [width]="'100%'" [height]="25" [disabled]="!canEdit">
      </jqxInput>
    </div>
  </div>

  <div style="float: left; margin-top: 5px; clear: both; display: contents;">
    <div style="float: left; width: calc(50% - 25px); height: 340px;">
      <div style="float: none; padding-top: 4px;">{{translate('Subflota')}} {{subflotaEdit.Nombre}}
        ({{movilesSubflota.length}})</div>
      <jqxGrid #gridMoviles2 [theme]="environment.tema" [height]="'100%'" [width]="'100%'" [appCellClick]
        [enablebrowserselection]="true" [columns]="columnsMoviles" [source]="dataAdapterMoviles2" [columnsresize]="true"
        [sortable]="true" [selectionmode]="'checkbox'" [showrowlines]="false" [showcolumnlines]="true" [altrows]="true"
        [filterable]="true" [autoshowfiltericon]="true" [filterrowheight]="30" [rowsheight]="20" [columnsheight]="25"
        [localization]="langGrid" [disabled]="!canEdit" [filter]="filter"
        [updatefilterconditions]="updatefilterconditions">
      </jqxGrid>
    </div>
    <div style="float: left; margin-left: 6px; margin-top: 150px;">
      <jqxButton style="float:left; clear: both;" [width]='25' [height]='26' textImageRelation="imageBeforeText"
        [textPosition]='"right"' [imgPosition]='"left"' [imgSrc]='"/assets/images/derecha.png"'
        (onClick)="onMenosClick($event)" [disabled]="!canEdit">
      </jqxButton>
      <jqxButton style="float:left; clear: both; margin-top: 5px;" [width]='25' [height]='26'
        [textImageRelation]='"imageAfterText"' [textPosition]='"left"' [imgPosition]='"right"'
        [imgSrc]='"/assets/images/izquierda.png"' (onClick)="onMasClick($event)" [disabled]="!canEdit">
      </jqxButton>

    </div>
    <div style="float: left; margin-left: 4px; width: calc(50% - 25px); height: 340px;">
      <div style="float: none; padding-top: 4px;">{{translate('Resto_flota')}} ({{movilesResto.length}})</div>
      <jqxGrid #gridMoviles1 [theme]="environment.tema" [height]="'100%'" [width]="'100%'" [appCellClick]
        [columns]="columnsMoviles" [source]="dataAdapterMoviles1" [columnsresize]="true" [sortable]="true"
        [selectionmode]="'checkbox'" [showrowlines]="false" [showcolumnlines]="true" [enablebrowserselection]="true"
        [showrowlines]="false" [altrows]="true" [filterable]="true" [autoshowfiltericon]="true" [filterrowheight]="30"
        [rowsheight]="20" [columnsheight]="25" [localization]="langGrid" [filter]="filter"
        [updatefilterconditions]="updatefilterconditions" [disabled]="!canEdit">
      </jqxGrid>
    </div>
  </div>

</mcg-window>
